/**
 * Downloads a file passed in. This is not compatible with React Native.
 *
 * @param containerDocument Document container.
 * @param file File to download
 */
export const downloadFile = (containerDocument: Document, file: File) => {
  const objectUrl = URL.createObjectURL(file);
  try {
    downloadFileFromUrl(containerDocument, objectUrl, file.name);
  } finally {
    // Ensure we don't leak memory.
    URL.revokeObjectURL(objectUrl);
  }
};

export const downloadFileFromUrl = (containerDocument: Document, url: string, fileName: string) => {
  const tempTag = containerDocument.createElement('a');
  tempTag.href = url;
  tempTag.download = fileName;
  containerDocument.body.append(tempTag);
  tempTag.click();
  containerDocument.body.removeChild(tempTag);
};

// Ideally, we would fix bad File descriptors once right after they're created, via new File() but Edge doesn't support this constructor.
export function getFileContentType(file: File) {
  // Windows 10 can report a bad content type for PTX files.
  if (file.type.toLowerCase() === 'image/ptx') {
    return '';
  }

  return file.type;
}
